import { motion } from "framer-motion";
import { PLATFORM_META, Arrow } from "../data/platforms";

const EASE = [0.16, 1, 0.3, 1];

function AccountCard({ platform, account, index, chapterId }) {
  const meta = PLATFORM_META[platform] || {};
  const Icon = meta.Icon;
  return (
    <motion.a
      data-testid={`link-card-${chapterId}-${platform.toLowerCase()}-${index}`}
      href={account.url}
      target="_blank"
      rel="noopener noreferrer"
      className="group border border-white/15 bg-black hover:bg-white transition-colors duration-200 p-6 flex items-center justify-between gap-4"
    >
      <div className="flex items-center gap-4 min-w-0">
        {Icon && <Icon className="w-6 h-6 shrink-0 text-white group-hover:text-black transition-colors duration-200" strokeWidth={1.5} />}
        <div className="min-w-0">
          <p className="font-sync text-[10px] tracking-[0.25em] uppercase text-white/50 group-hover:text-black/60 transition-colors duration-200">
            {meta.color}
          </p>
          <p className="font-mono-t text-lg md:text-xl text-white group-hover:text-black transition-colors duration-200 truncate">
            {account.handle}
          </p>
        </div>
      </div>
      <Arrow className="w-5 h-5 shrink-0 text-white group-hover:text-black translate-x-0 group-hover:translate-x-1 transition-all duration-200" strokeWidth={1.5} />
    </motion.a>
  );
}

export default function LinkChapter({ chapter }) {
  return (
    <section data-testid={`chapter-${chapter.id}`} className="max-w-7xl mx-auto w-full px-4 sm:px-6 py-10 md:py-14">
      <motion.h2
        className="font-gothic text-3xl md:text-5xl leading-none border-b border-white/10 pb-4 mb-8"
      >
        {chapter.title}
      </motion.h2>

      {chapter.comingSoon ? (
        <div
          data-testid={`coming-soon-${chapter.id}`}
          className="border border-white/15 border-dashed p-10 flex items-center justify-center"
        >
          <span className="font-sync text-xs md:text-sm tracking-[0.3em] uppercase text-white/40">
            Coming Soon
          </span>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {chapter.categories.flatMap((cat, ci) =>
            cat.accounts.map((acc, ai) => (
              <AccountCard
                key={`${cat.platform}-${ai}`}
                platform={cat.platform}
                account={acc}
                index={ci + ai}
                chapterId={chapter.id}
              />
            ))
          )}
        </div>
      )}
    </section>
  );
}
